
export class BreadCrumbModel {
  code: string;
  description: string;
  routerLink:string;
  
}


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/models/campaign-3-breadcrumb.model.ts